import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Label
} from "reactstrap";
import Page from "components/Page";
import { Textbox, Textarea } from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchCalcularCotizacionAP, FetchDescargarCotizacion, FetchEnviaCotizacion, fetchRecuperarCarritoAP, resetStateAP } from "../../redux/actions/aRamoAccidentesPersonales";

import LoadingScreen from "react-loading-screen";
import ValoresCotizacionAPersonal from "./ValoresCotizacionAPersonal";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from 'date-fns';
import { TravelAccidentesPersonales } from "../../constants";
import EmisionRetroactiva from "../CotizacionPymes/EmisionRetroactiva";



class ListadoProductoAPersonal extends React.Component {

  constructor(props) {
    super(props);

    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarritoUrl = queryParams.get("id");

    let idCarritoAct = '';

    if (idCarritoUrl !== undefined && idCarritoUrl !== null && idCarritoUrl !== "") {
      idCarritoAct = idCarritoUrl;
    } else {
      idCarritoAct = this.props.datosCarritoAPTravelGroup.carritoAPTravelGroup['mongoCarrito']
    }

    //  const dir = this.props.datosRecuperarCarritoAP.recuperarCarritoAP.datosUbicacion.direccion
    //  const ciu =  this.props.datosRecuperarCarritoAP.recuperarCarritoAP.datosUbicacion.ciudad
    //  const prov= this.props.datosRecuperarCarritoAP.recuperarCarritoAP.datosUbicacion.provincia


    this.state = {
      validate: false,
      numDias: "365",
      hasNumDiasError: false,
      primaDia: '',
      primaTotal: '',
      vigenciaDesde: '',
      vigenciaHasta: '',
      diasVigencia: '',
      primaNeta: '',
      formEditado: false,
      sumaImpuestos: '',
      idCarrito: idCarritoAct,
      idPlan: '',
      okDescarga: false,
      linkDescarga: '',
      okEnvio: false,
      idEmpresa: '',
      idPersona: '',
      nomEmpresa: '',
      nomPersona: '',
      provincia: '',
      ciudad: '',
      direccion: '',
      vigenciaRetroactiva: new Date(),
      requiereEmision: false,
      ramfecFuturo: null,
      ramfecRetroactividad: null,
      errorVigenciaRetroactiva: false,
      bloqueoPorRiesgo: false

    };

    this.onClickRegresar = this.onClickRegresar.bind(this);

  }


  componentDidUpdate(prevProps, prevState) {

    if (prevState.numDias !== this.state.numDias && this.state.numDias >= TravelAccidentesPersonales.minDias) {
      console.log('se recalcula')
      this.setState({ formEditado: true })
      // this.recalculaValores()
    }
  }



  async componentDidMount() {
    this.props.resetStateAP();
    window.scroll(0, 0);

    await this.props.recuperarCarrito({ idCarrito: this.state.idCarrito });

    if (!this.props.datosRecuperarCarritoAP.recuperarCarritoAPIsLoading && !this.props.datosRecuperarCarritoAP.recuperarCarritoAPhasError && this.props.datosRecuperarCarritoAP.recuperarCarritoAP) {

      let datosUbicacion = this.props.datosRecuperarCarritoAP.recuperarCarritoAP.datosUbicacion

      const { idEmpresa, idPersona, nomEmpresa, nomPersona, fechaInicioVigencia, fechaFinVigencia, diasVigencia, primaDia, numDias, primaNeta, primaTotal } = this.props.datosRecuperarCarritoAP.recuperarCarritoAP

      this.setState({
        ciudad: datosUbicacion.ciudad,
        provincia: datosUbicacion.provincia,
        direccion: datosUbicacion.direccion,
        idCarrito: this.state.idCarrito,
        idPlan: this.props.datosRecuperarCarritoAP.recuperarCarritoAP.codProd,
        idEmpresa,
        idPersona,
        nomEmpresa,
        nomPersona,
        vigenciaDesde: fechaInicioVigencia,
        vigenciaHasta: fechaFinVigencia,
        diasVigencia,
        primaDia,
        numDias,
        primaNeta,
        primaTotal
      }, this.recalculaValores)

    } else {

      await this.props.calculoCotizacion({
        "empresa": "AIGMETROPOLITANA",
        "codProducto": this.state.idPlan,
        "numDias": this.state.numDias,
        "idCarrito": this.state.idCarrito,
      })

    }


    console.log('estadito', this.state)




    /*  this.setState({
          idCarrito:this.props.datosCarritoAPTravelGroup.carritoAPTravelGroup['mongoCarrito']
      })  */

  }


  recalculaValores = async () => {

    this.setState({
      okDescarga: false,
      linkDescarga: '',
      okEnvio: false
    })

    const { vigenciaDesde, vigenciaHasta } = this.state


    await this.props.calculoCotizacion({
      "empresa": "AIGMETROPOLITANA",
      "codProducto": this.state.idPlan,
      "numDias": this.state.numDias,
      "idCarrito": this.state.idCarrito,
      "fechaInicioVigencia": vigenciaDesde,
      "fechaFinVigencia": vigenciaHasta
    })

    this.setState({
      formEditado: false
    })
  }

  cambiaFechaVigenciaDesde = e => {
    this.setState({
      vigenciaDesde: e,
      formEditado: true
    })
  }


  cambiaFechaVigenciaHasta = e => {
    this.setState({
      vigenciaHasta: e,
      formEditado: true
    })
  }


  async onClickRegresar(e) {
    this.props.history.replace({
      pathname: `/servicios-cotizacion-accidente`
    });
  }




  async onDescargar(event) {

    this.setState({
      okDescarga: false,
      linkDescarga: ''
    })

    event.preventDefault()
    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "descargar",
      correo: "",
      idCarrito: this.state.idCarrito
    }

    await this.props.descargarCotizacion(datosJson)

    if (!this.props.generarCotizacionPdfAP.generarCotizacionAPhasError) {

      this.setState({
        okDescarga: true,
        linkDescarga: this.props.generarCotizacionPdfAP.generarCotizacionAP.url
      })

    }
    //let datosPago=this.props.datosCotizacion.datosDescarga;
    /*  if (!this.props.datosCotizacion.generarCotizacionHasError) {
        //let newTab = window.open();
        //window.location.href = datosPago.urlPdf;
        //window.open(datosPago.urlPdf, "_blank")
      } */

  }


  async onEnviar(event, correo) {
    event.preventDefault()

    this.setState({
      okEnvio: false,
      linkDescarga: ''
    })

    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "enviar",
      correo: correo,
      idCarrito: this.state.idCarrito
    }

    await this.props.enviarCotizacion(datosJson)

    if (!this.props.datosEnviarCotizacionPdfAP.enviarCotizacionAPhasError) {

      this.setState({
        okEnvio: true,
        linkDescarga: this.props.generarCotizacionPdfAP.generarCotizacionAP.url
      })

    }

    //let datosPago=this.props.datosCotizacion.datosDescarga;
    /*if (!this.props.datosCotizacion.generarCotizacionHasError) {
      //let newTab = window.open();
      //window.location.href = datosPago.urlPdf;
      //window.open(datosPago.urlPdf, "_blank")
    } */

  }



  render() {
    const { numDias, formEditado, idEmpresa, idPersona, nomEmpresa, nomPersona, ciudad, provincia, direccion, vigenciaDesde, vigenciaHasta, vigenciaRetroactiva, requiereEmision, ramfecFuturo, errorVigenciaRetroactiva, ramfecRetroactividad, bloqueoPorRiesgo } = this.state;

    const { primaDia, primaTotal, diasVigencia, primaNeta, sumaImpuestos, impuestos, valorDia } = this.props.datosCalculosCotizacionAP.calculoCotizacionAP;

    console.log('los dias de vigencia son:', diasVigencia)

    let texto = 'Cargando...'

    {
      this.props.generarCotizacionPdfAP.generarCotizacionCarritoAPIsLoading ? texto = 'Estamos generando tu cotización' :
        this.props.datosEnviarCotizacionPdfAP.enviarCotizacionCarritoAPIsLoading ? texto = 'Estamos enviando tu cotización' :
          texto = 'Cargando...'

    }

    return (

      <LoadingScreen
        loading={this.props.datosCalculosCotizacionAP.calculoCotizacionAPIsLoading || this.props.datosCalculosCotizacionAP.emisionRetroactivaIsLoading || this.props.generarCotizacionPdfAP.generarCotizacionCarritoAPIsLoading || this.props.datosEnviarCotizacionPdfAP.enviarCotizacionCarritoAPIsLoading || this.props.datosRecuperarCarritoAP.recuperarCarritoAPIsLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={texto}
      >



        <Page
          title="Cotización Travel Guard"
          breadcrumbs={[{ name: "Cotización linea financiera", active: true }]}
        >
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step"> {` 1. Cotización `} </div>
                    <div className="step current"> {` 2. Resumen `} </div>
                    <div className="step"> {` 3. Confirmación `} </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                    <div class="step"> {` 5. Formulario de Vinculación `} </div>
                    <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>



          <Row>
            <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box" >

              <div>
                <Card className="flex-row">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }}>Resumen.</h4>
                    <p />


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>RUC:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{idEmpresa} </Col>
                    </Row>


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Nombre de la empresa:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{nomEmpresa} </Col>
                    </Row>


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>CI del solicitante:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{idPersona} </Col>
                    </Row>


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Nombre del solicitante:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{nomPersona} </Col>
                    </Row>


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Provincia:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{provincia.label} </Col>
                    </Row>



                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Ciudad:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{ciudad.label} </Col>
                    </Row>


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Dirección:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{direccion} </Col>
                    </Row>





                    <hr style={{ borderTop: "1px solid" }}></hr>

                    <br />

                                <h4 style={{ fontWeight: "bold" }}>PLAN DE VIAJES CORPORATIVOS</h4>
                                <p/>


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >
                        <h4>Número de días que desea contratar </h4>
                        <p style={{ fontWeight: "100" }} >Mínimo de dias a contratar {TravelAccidentesPersonales.minDias}</p>
                      </Col>


                      <Col lg={5} md={5} sm={5} xs={12} >

                        <Textbox
                          //tabIndex="1" // Optional.[String or Number].Default: none.
                          id='numDias'// Optional.[String].Default: "".  Input ID.
                          name="numDias" // Optional.[String].Default: "". Input name.
                          type="text" // Optional.[String].Default: "text". Input type [text, password, number]. NOTE: provide "text" for better performance since different browsers run differently with "number".
                          value={numDias} // Optional.[String].Default: "".
                          placeholder="" // Optional.[String].Default: "".
                          onChange={(numDias, e) => {
                            let numerDias = numDias === '' ? '' : parseInt(numDias)
                            this.setState({
                              numDias: numerDias,
                              hasNumDiasError: numerDias >= TravelAccidentesPersonales.minDias ? false : true
                            });
                          }}

                          onBlur={e => {
                            this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}

                          validationOption={{
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                            min: TravelAccidentesPersonales.minDias, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                            //reg: /^[0-9]+$/, //Optional.[Bool].Default: "" Custom regex.
                            //regMsg:"Por favor ingrese solo carácteres númericos",
                            msgOnError: `Ingrese solo caráteres númericos y un mínimo de ${TravelAccidentesPersonales.minDias} días`
                          }}
                        />

                      </Col>

                    </Row>



                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Prima total por día:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >$ {valorDia} </Col>
                    </Row>



                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Prima total por los días:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >$ {primaTotal} </Col>
                    </Row>


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Vigencia desde:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{vigenciaDesde} </Col>
                    </Row>


                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Vigencia hasta:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} >{vigenciaHasta} </Col>
                    </Row>




                    <Row>
                      <Col lg={1} md={1} sm={1} xs={0} ></Col>
                      <Col lg={5} md={5} sm={5} xs={12} ><h4>Días de vigencia:</h4></Col>
                      <Col lg={5} md={5} sm={5} xs={12} > {diasVigencia} </Col>
                    </Row>

                    <br />



                    <Row>

                      <EmisionRetroactiva
                        ramo={'TRAVEL'}
                        vigenciaRetroactiva={vigenciaRetroactiva}
                        mensaje={'¿Se requiere la emisión con una vigencia retroactiva o futura? Por favor seleccionar únicamente en caso de necesitarlo'}
                        setVigenciaRetroactiva={(valor) => this.setState({ vigenciaRetroactiva: valor })}
                        requiereEmision={requiereEmision}
                        setRequiereEmision={(valor) => { this.setState({ requiereEmision: valor }) }}
                        setLoading={(valor) => { console.log(valor) }}
                        ramfecFuturo={ramfecFuturo}
                        ramfecRetroactividad={ramfecRetroactividad}
                        setRamfecFuturo={(valor) => { this.setState({ ramfecFuturo: valor }) }}
                        setRamfecRetroactividad={(valor) => { this.setState({ ramfecRetroactividad: valor }) }}
                        errorVigenciaRetroactiva={errorVigenciaRetroactiva}
                        setErrorVigenciaRetroactiva={(valor) => { this.setState({ errorVigenciaRetroactiva: valor }) }}
                        bloqueoPorRiesgo={bloqueoPorRiesgo}
                        setBloqueoPorRiesgo={(valor) => { this.setState({ bloqueoPorRiesgo: valor }) }}
                      />
                    </Row>



                    <Row style={{ marginTop: '40px' }}>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Button
                          className="btn btn-detail-gray"
                          onClick={this.onClickRegresar}
                        >
                          <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                          {"REGRESAR"}
                        </Button>
                      </Col>
                    </Row>




                  </CardBody>
                </Card>
              </div>


            </Col>

            <Col lg={4} md={12} className="detalle-impuestos-box" >
              <ValoresCotizacionAPersonal requiereEmision={requiereEmision} vigenciaRetroactiva={vigenciaRetroactiva} errorVigenciaRetroactiva={errorVigenciaRetroactiva || bloqueoPorRiesgo} formEditado={formEditado} primaNeta={primaNeta} primaTotal={primaTotal} metodoDescargar={this.onDescargar.bind(this)} metodoEnviar={this.onEnviar.bind(this)} sumaImpuestos={sumaImpuestos} paso={"valores-cotizacion"} impuestos={impuestos} accion={this.recalculaValores} okDescarga={this.state.okDescarga} okEnvio={this.state.okEnvio} idCarrito={this.state.idCarrito} hasNumDiasError={this.state.hasNumDiasError} linkDescarga={this.props.datosRecuperarCarritoAP.recuperarCarritoAP.urlPdf} />
            </Col>
          </Row>
        </Page>
      </LoadingScreen>
    );



  };

}

const mapStateToProps = state => ({
  datosCalculosCotizacionAP: state.datosCalculosCotizacionAP,
  datosCarritoAPTravelGroup: state.datosCarritoAPTravelGroup,
  datosProductoCarritoAPTravelGroup: state.datosProductoCarritoAPTravelGroup,
  generarCotizacionPdfAP: state.generarCotizacionPdfAP,
  datosEnviarCotizacionPdfAP: state.datosEnviarCotizacionPdfAP,
  datosRecuperarCarritoAP: state.datosRecuperarCarritoAP,
});

const mapDispatchToProps = dispatch => {
  return {
    calculoCotizacion: datos => dispatch(fetchCalcularCotizacionAP(datos)),
    descargarCotizacion: (datos) => dispatch(FetchDescargarCotizacion(datos)),
    enviarCotizacion: (datos) => dispatch(FetchEnviaCotizacion(datos)),
    recuperarCarrito: (datos) => dispatch(fetchRecuperarCarritoAP(datos)),
    resetStateAP: () => dispatch(resetStateAP()),
  };
};


export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ListadoProductoAPersonal)
);
